import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'bootstrap/dist/css/bootstrap.css';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js';

// Import Font Awesome
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

// Add the WhatsApp icon to the library
library.add(faWhatsapp);

// Register the Font Awesome component globally
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(bootstrap);

new Vue({
  router,
  render: h => h(App),
  mounted() {
    // Signal to the prerenderer that the app has finished rendering.
    document.dispatchEvent(new Event('render-event'));
  }
}).$mount('#app');
